<header class="weHeader">
	<div class="weHeader__bar">
		<div class="weRow">
			<div class="weHeader__barContainer weCol">
				<!-- Logo section -->
				<a class="weHeader__barLogoLink" href="/">
					<app-icon
						class="weHeader__barLogoSvg"
						name="logo"
						title="Würth Elektronik Logo"
						viewBox="0 0 46 46"
						[size]="46" />
					<app-icon
						class="weHeader__barLogoName"
						name="logoTypo"
						title="Würth Elektronik Logo"
						viewBox="0 0 89 27"
						[height]="27"
						[width]="89" />
				</a>
				<div class="weHeader__barSeparator"></div>
				<!-- Main Navigation -->
				<nav class="weHeader__barNav">
					<ul class="weHeader__barNavList">
						<li class="weHeader__barNavItem">
							<a
								class="weHeader__barNavLink"
								routerLink="/dashboard"
								routerLinkActive="weHeader__barNavLink--current"
								(click)="closeMobileMenuIfOpen()"
								>{{ 'APP.DASHBOARD' | translate }}</a
							>
						</li>
						<li class="weHeader__barNavItem">
							<a
								class="weHeader__barNavLink"
								routerLink="/user-profile"
								routerLinkActive="weHeader__barNavLink--current"
								(click)="closeMobileMenuIfOpen()"
								>{{ 'APP.USER_PROFILE' | translate }}</a
							>
						</li>
						<li class="weHeader__barNavItem">
							<a
								class="weHeader__barNavLink"
								routerLink="/api-credentials"
								routerLinkActive="weHeader__barNavLink--current"
								(click)="closeMobileMenuIfOpen()"
								>{{ 'APP.API_CREDENTIALS' | translate }}</a
							>
						</li>
						<!-- <li class="weHeader__barNavItem">
            <a class="weHeader__barNavLink" routerLink="/digital-services" routerLinkActive="weHeader__barNavLink--current" (click)="closeMobileMenuIfOpen()">{{ 'APP.DIGITALSERVICES' | translate }}</a>
          </li> -->
						<!-- Additional navigation items can be uncommented as needed -->
						<!-- <li class="weHeader__barNavItem">
          <a class="weHeader__barNavLink" routerLink="/dashboard" routerLinkActive="weHeader__barNavLink--current" (click)="closeMobileMenuIfOpen()">{{ 'APP.DASHBOARD' | translate }}</a>
        </li> -->
					</ul>
				</nav>

				<!-- Header Bar Tools -->
				<div class="weHeader__barTools">
					<!-- Search button for small screens -->
					<!-- <button class="weHeader__barToolsButton weUtils__dBlock weUtils__dNone--md" aria-label="Search">
      <svg class="weHeader__barToolsIcon" width="24" height="24">
        <use href="#webSvg__search-24"></use>
      </svg>
    </button> -->

					<!-- User login/profile -->
					@if (authService.isAuthenticated$ | async) {
						<dl class="weUtilsFlyout weHeader__barFlyout" tabindex="0" [class.weUtilsFlyout--open]="isUserMenuOpen">
							@if (shouldShowSubHeader()) {
								<dt class="weUtilsFlyout__label">
									<button class="weUser__profile weHeader__barToolsButton" (click)="toggleUserMenu()">
										<div class="weUser__avatar">
											@if (userService.hasUserData() && userService.getUserInitials() !== '') {
												<span class="weUser__initials">{{ userService.getUserInitials() }}</span>
											} @else {
												<app-icon
													aria-hidden="true"
													class="weUser__avatarIcon"
													name="user-24"
													[height]="24"
													[width]="24" />
											}
										</div>
									</button>
								</dt>
								<dd class="weUtilsFlyout__panel weUtilsFlyout__panel--bottom">
									<div class="weHeaderUser__panel">
										<ul class="weHeader__barFlyoutMenu">
											<li class="weHeader__barFlyoutMenuItem">
												<a class="weHeader__barFlyoutMenuLink" routerLink="/user-profile" (click)="navigateToProfile()">
													<app-icon name="user-18" viewBox="0 0 18 18" [size]="18" />
													<span class="weHeaderUser__panelName">{{ userService.getUserFullName() }}</span>
												</a>
											</li>
											<li class="weHeader__barFlyoutMenuItem">
												<a
													class="weHeader__barFlyoutMenuLink"
													role="button"
													tabindex="0"
													(click)="logout()"
													(keydown.enter)="logout()"
													(keydown.space)="$event.preventDefault(); logout()">
													<app-icon name="logout" viewBox="0 0 18 18" [size]="18" />
													{{ 'AUTH.LOGOUT' | translate }}
												</a>
											</li>
										</ul>
									</div>
									<div class="weUtilsFlyout__panelHandle"></div>
								</dd>
							}
						</dl>
					} @else {
						<button
							class="weUser__profile weHeader__barToolsButton weUtils__dNone weUtils__dFlex--lg"
							(click)="login()">
							<div class="">
								<app-icon class="weUser__avatarIcon" name="user-24" [height]="24" [width]="24" />
							</div>
							<span class="weUser__name">{{ 'AUTH.LOGIN' | translate }}</span>
						</button>
					}

					<!-- Address Number Selector (dev only) -->
					@if (
						!environmentService.isProduction &&
						(authService.isAuthenticated$ | async) &&
						addressNumberService.showDropdown
					) {
						<dl
							class="weUtilsFlyout weHeader__barFlyout weHeader__addressNumberFlyout"
							tabindex="0"
							[class.weUtilsFlyout--open]="isAddressNumberMenuOpen">
							<dt class="weUtilsFlyout__label">
								<button
									class="weHeader__barToolsButton weHeader__addressNumberToggle weUtils__dNone weUtils__dFlex--lg weHeader__barToolsButton--thin"
									(click)="toggleAddressNumberMenu()">
									<app-icon class="weHeader__barToolsIcon" name="filter" viewBox="0 0 24 24" [size]="24" />
									<span class="weHeader__barToolsLabel">{{
										addressNumberService.selectedAddressNumber || 'Addr#'
									}}</span>
								</button>
							</dt>
							<dd class="weUtilsFlyout__panel weUtilsFlyout__panel--bottom">
								<div class="weHeaderUser__panel">
									<ul class="weHeader__barFlyoutMenu">
										<li class="weHeader__addressNumberLabel">Address Number</li>
										<li class="weHeader__addressNumberSearchItem">
											<input
												class="weHeader__addressNumberSearchInput"
												placeholder="Search..."
												type="text"
												[(ngModel)]="addressNumberFilter"
												(click)="$event.stopPropagation()" />
										</li>
									</ul>
									<ul class="weHeader__barFlyoutMenu weHeader__addressNumberList">
										@for (entry of filteredAddressNumbers; track entry.addressNumber) {
											<li class="weHeader__barFlyoutMenuItem">
												<a
													class="weHeader__barFlyoutMenuLink"
													role="button"
													tabindex="0"
													[class.weHeader__barFlyoutMenuLink--active]="
														addressNumberService.selectedAddressNumber === entry.addressNumber
													"
													(click)="selectAddressNumber(entry.addressNumber)"
													(keydown.enter)="selectAddressNumber(entry.addressNumber)"
													(keydown.space)="$event.preventDefault(); selectAddressNumber(entry.addressNumber)">
													{{ entry.addressNumber }}
													<span class="weHeader__addressNumberBu">({{ entry.businessUnit }})</span>
												</a>
											</li>
										}
									</ul>
								</div>
								<div class="weUtilsFlyout__panelHandle weUtilsFlyout__panelHandle--translateY"></div>
							</dd>
						</dl>
					}

					<!-- Language Switcher -->
					<dl class="weUtilsFlyout weHeader__barFlyout" tabindex="0" [class.weUtilsFlyout--open]="isLanguageMenuOpen">
						<dt class="weUtilsFlyout__label">
							<button
								class="weHeader__barToolsButton weUtils__dNone weUtils__dFlex--lg weHeader__barToolsButton--thin"
								(click)="toggleLanguageMenu()">
								<app-icon class="weHeader__barToolsIcon" name="world" viewBox="0 0 24 24" [size]="24" />
								<span class="weHeader__barToolsLabel">{{ translateService.currentLang.toUpperCase() }}</span>
							</button>
						</dt>
						<dd class="weUtilsFlyout__panel weUtilsFlyout__panel--bottom">
							<ul class="weHeader__barFlyoutMenu weUtils__languageNavigation">
								<li class="weHeader__barFlyoutMenuItem">
									<a
										class="weHeader__barFlyoutMenuLink"
										hreflang="en"
										lang="en"
										role="button"
										tabindex="0"
										(click)="switchLanguage('en'); toggleLanguageMenu()"
										(keydown.enter)="switchLanguage('en'); toggleLanguageMenu()"
										(keydown.space)="$event.preventDefault(); switchLanguage('en'); toggleLanguageMenu()"
										>English</a
									>
								</li>
								<li class="weHeader__barFlyoutMenuItem">
									<a
										class="weHeader__barFlyoutMenuLink"
										hreflang="de"
										lang="de"
										role="button"
										tabindex="0"
										(click)="switchLanguage('de'); toggleLanguageMenu()"
										(keydown.enter)="switchLanguage('de'); toggleLanguageMenu()"
										(keydown.space)="$event.preventDefault(); switchLanguage('de'); toggleLanguageMenu()"
										>Deutsch</a
									>
								</li>
							</ul>
							<div class="weUtilsFlyout__panelHandle weUtilsFlyout__panelHandle--translateY"></div>
						</dd>
					</dl>

					<!-- Mobile menu button -->
					<button
						aria-label="Toggle navigation menu"
						class="weHeader__barToolsButton weUtils__dNone--lg"
						(click)="toggleMobileMenu()">
						<app-icon class="weHeader__barToolsIcon" name="menu" [height]="24" [width]="24" />
						<span class="weHeader__barToolsLabel">{{ 'COMMON.MENU' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		@if (userService.hasUserData() && !errorState.isFatalErrorActive() && shouldShowSubHeader()) {
			<div class="weRow weUtils__dNone weUtils__dFlex--lg">
				<div class="weHeader__barSubContainer weCol">
					<nav class="weHeader__barNav">
						<ul class="weHeader__barNavList weUtils__dNone weUtils__dFlex--lg">
							<li class="weHeader__barNavItem">
								<a
									class="weHeader__barNavLink"
									routerLink="/dashboard"
									routerLinkActive="weHeader__barNavLink--current"
									(click)="closeMobileMenuIfOpen()"
									>{{ 'APP.DASHBOARD' | translate }}</a
								>
							</li>
							<li class="weHeader__barNavItem">
								<a
									class="weHeader__barNavLink"
									routerLink="/user-profile"
									routerLinkActive="weHeader__barNavLink--current"
									(click)="closeMobileMenuIfOpen()"
									>{{ 'APP.USER_PROFILE' | translate }}</a
								>
							</li>
							<li class="weHeader__barNavItem">
								<a
									class="weHeader__barNavLink"
									routerLink="/api-credentials"
									routerLinkActive="weHeader__barNavLink--current"
									(click)="closeMobileMenuIfOpen()"
									>{{ 'APP.API_CREDENTIALS' | translate }}</a
								>
							</li>
							<!-- <li class="weHeader__barNavItem">
          <a class="weHeader__barNavLink" routerLink="/digital-services" routerLinkActive="weHeader__barNavLink--current" (click)="closeMobileMenuIfOpen()">{{ 'APP.DIGITALSERVICES' | translate }}</a>
        </li> -->
						</ul>
						<!-- Mobile navigation - show currently active link as dropdown on smaller screens -->
						<div class="weHeader__mobileDropdown weUtils__dBlock weUtils__dNone--lg">
							<button class="weHeader__mobileDropdownToggle" (click)="toggleExtraLinksMenu()">
								<span>{{ getCurrentActiveLink() }}</span>
								<app-icon
									class="weHeader__dropdownIcon"
									name="arrowDown"
									[class.weHeader__dropdownIcon--open]="isExtraLinksMenuOpen"
									[height]="16"
									[width]="16" />
							</button>
						</div>
					</nav>
				</div>
			</div>
		}

		<!-- Full-width dropdown panel - positioned outside the container for full width -->
		@if (userService.hasUserData()) {
			<div
				class="weHeader__fullWidthDropdown weUtils__dNone--lg"
				[class.weHeader__fullWidthDropdown--open]="isExtraLinksMenuOpen">
				<div class="weRow">
					<div class="weCol">
						<ul class="weHeader__fullWidthDropdownMenu">
							<li class="weHeader__fullWidthDropdownItem">
								<a
									class="weHeader__fullWidthDropdownLink"
									routerLink="/dashboard"
									routerLinkActive="weHeader__fullWidthDropdownLink--active"
									(click)="selectExtraLink()"
									>{{ 'APP.DASHBOARD' | translate }}</a
								>
							</li>
							<li class="weHeader__fullWidthDropdownItem">
								<a
									class="weHeader__fullWidthDropdownLink"
									routerLink="/user-profile"
									routerLinkActive="weHeader__fullWidthDropdownLink--active"
									(click)="selectExtraLink()"
									>{{ 'APP.USER_PROFILE' | translate }}</a
								>
							</li>
							<li class="weHeader__fullWidthDropdownItem">
								<a
									class="weHeader__fullWidthDropdownLink"
									routerLink="/api-credentials"
									routerLinkActive="weHeader__fullWidthDropdownLink--active"
									(click)="selectExtraLink()"
									>{{ 'APP.API_CREDENTIALS' | translate }}</a
								>
							</li>
							<!-- <li class="weHeader__fullWidthDropdownItem">
          <a class="weHeader__fullWidthDropdownLink" routerLink="/digital-services" routerLinkActive="weHeader__fullWidthDropdownLink--active" (click)="selectExtraLink()">{{ 'APP.DIGITALSERVICES' | translate }}</a>
        </li> -->
						</ul>
					</div>
				</div>
			</div>
		}
	</div>

	<!-- Mobile Navigation Menu - shown when menu is toggled -->
	@if (userService.hasUserData() && !errorState.isFatalErrorActive()) {
		<div class="weHeader__mobileMenu" [class.weHeader__mobileMenu--open]="isMobileMenuOpen">
			<div class="weHeader__mobileMenuContainer">
				<nav class="weHeader__mobileNav">
					<!-- Mobile navigation items -->
					<ul class="weHeaderMenu__menu">
						<li class="weHeaderMenu__menuItem">
							<a
								class="weHeaderMenu__menuLink"
								routerLink="/dashboard"
								routerLinkActive="weHeaderMenu__menuLink--current"
								(click)="closeMobileMenuIfOpen()">
								<span class="weHeaderMenu__menuLabel">
									<span class="weHeaderMenu__menuLabelText">{{ 'APP.DASHBOARD' | translate }}</span>
								</span>
							</a>
						</li>
						<li class="weHeaderMenu__menuItem">
							<a
								class="weHeaderMenu__menuLink"
								routerLink="/user-profile"
								routerLinkActive="weHeaderMenu__menuLink--current"
								(click)="closeMobileMenuIfOpen()">
								<span class="weHeaderMenu__menuLabel">
									<span class="weHeaderMenu__menuLabelText">{{ 'APP.USER_PROFILE' | translate }}</span>
								</span>
							</a>
						</li>
						<li class="weHeaderMenu__menuItem">
							<a
								class="weHeaderMenu__menuLink"
								routerLink="/api-credentials"
								routerLinkActive="weHeaderMenu__menuLink--current"
								(click)="closeMobileMenuIfOpen()">
								<span class="weHeaderMenu__menuLabel">
									<span class="weHeaderMenu__menuLabelText">{{ 'APP.API_CREDENTIALS' | translate }}</span>
								</span>
							</a>
						</li>
						<!-- <li class="weHeaderMenu__menuItem">
          <a class="weHeaderMenu__menuLink" routerLink="/digital-services" routerLinkActive="weHeaderMenu__menuLink--current" (click)="closeMobileMenuIfOpen()">
            <span class="weHeaderMenu__menuLabel">
              <span class="weHeaderMenu__menuLabelText">{{ 'APP.DIGITALSERVICES' | translate }}</span>
            </span>
          </a>
        </li> -->
						<!-- Additional mobile navigation items can be added here -->
					</ul>
					<!-- Mobile language switcher -->
					<dl
						class="weUtilsFlyout weHeader__mobileLangFlyout"
						tabindex="0"
						[class.weUtilsFlyout--open]="isMobileLangOpen">
						<dt class="weUtilsFlyout__label">
							<button
								class="weHeader__mobileLangToggle"
								[attr.aria-expanded]="isMobileLangOpen"
								(click)="isMobileLangOpen = !isMobileLangOpen; $event.stopPropagation()">
								<span class="weHeader__mobileLangToggleLabel">{{ i18nService.getCurrentLanguageLong() }}</span>
							</button>
						</dt>
						<dd class="weUtilsFlyout__panel weUtilsFlyout__panel--bottom weUtilsFlyout__panel--mobile">
							<ul class="weHeader__barFlyoutMenu weUtils__languageNavigation">
								<li class="weHeader__barFlyoutMenuItem">
									<a
										class="weHeader__barFlyoutMenuLink"
										hreflang="en"
										lang="en"
										role="button"
										tabindex="0"
										[class.weHeader__barFlyoutMenuLink--active]="translateService.currentLang === 'en'"
										(click)="switchLanguage('en'); isMobileLangOpen = false; $event.stopPropagation()"
										(keydown.enter)="switchLanguage('en'); isMobileLangOpen = false"
										(keydown.space)="$event.preventDefault(); switchLanguage('en'); isMobileLangOpen = false"
										>English</a
									>
								</li>
								<li class="weHeader__barFlyoutMenuItem">
									<a
										class="weHeader__barFlyoutMenuLink"
										hreflang="de"
										lang="de"
										role="button"
										tabindex="0"
										[class.weHeader__barFlyoutMenuLink--active]="translateService.currentLang === 'de'"
										(click)="switchLanguage('de'); isMobileLangOpen = false; $event.stopPropagation()"
										(keydown.enter)="switchLanguage('de'); isMobileLangOpen = false"
										(keydown.space)="$event.preventDefault(); switchLanguage('de'); isMobileLangOpen = false"
										>Deutsch</a
									>
								</li>
							</ul>
							<div class="weUtilsFlyout__panelHandle"></div>
						</dd>
					</dl>
				</nav>
			</div>
		</div>
	}
</header>
